module.exports = __webpack_public_path__ + "static/img/customer-address-pin.4953fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doorder/customer-address-pin.png
// module id = 5dbn
// module chunks = 0